import React from 'react';
import hero from '../assets/hero.png';

const HeroSection = () => {
  return (
    <section className="w-full px-4 sm:px-6 lg:px-12 xl:px-16 2xl:px-24 py-4 md:py-8 lg:py-12">
      <div className="max-w-screen-2xl mx-auto">
        
        {/* 85% width wrapper for both text and image with margin top */}
        <div className="w-[80%] mx-auto mt-12">
          <div className="flex items-center mb-4 md:mb-6 lg:mb-8">
            <div 
              className="w-6 md:w-8 lg:w-12 h-px mr-2 md:mr-4 lg:mr-6"
              style={{ background: 'rgba(243, 255, 71, 1)' }}
            />
            <div 
              className="text-gray-300 text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl"
              style={{ fontFamily: 'Space Grotesk', fontWeight: '500' }}
            >
              Global Independent Design Studio for AI Startups
            </div>
          </div>

          <div className="mb-8 md:mb-12 lg:mb-16">
            <img 
              src={hero} 
              alt="hero" 
              className="w-full h-auto object-contain"
            />
          </div>
        </div>

      </div>
    </section>
  );
};

export default HeroSection;
